<template>
	<div style="height: calc(100vh - 90px); overflow-x: hidden; overflow-y: auto;">
		<div>
			<Row style="margin-top: 20px;">
				<Col span=24>
				<Card
					style="margin-bottom: 10px;box-shadow: 2px 2px 4px #a7a7a7;width: 100%;height:70px;white;color: #000000;background-color: white;">
					<Form ref="formInline" :model="formInline" inline style="text-align: left;">
						<FormItem prop="trackName" label="充电站:" :label-width="60">
							<Select placeholder="站点列表" style="width: 120px;" v-model="formInline.StationId">
								<Option :value=0>全部</Option>
								<Option v-bind:key="item.StationId" v-for="(item) in StationList"
									:value="item.StationId">{{item.StationName}}</Option>
							</Select>
						</FormItem>
						<FormItem prop="trackName" label="流量方" :label-width="100">
							<Select placeholder="流量方" style="width: 120px;" v-model="formInline.PaymentMode">
								<Option :value=0>全部</Option>
								<Option v-bind:key="item.Id" v-for="(item) in PaymentModeList"
									:value="item.Id">{{item.Name}}</Option>
							</Select>
						</FormItem>
						<FormItem prop="trackName" label="查询类型:" :label-width="100">
							<Select placeholder="查询类型" style="width: 70px;" @on-change="changelegend_data"
								v-model="formInline.dateType">
								<!-- <Option value="date">按日</Option> -->
								<Option value="month">按月</Option>
								<Option value="year">按年</Option>
							</Select>
						</FormItem>
						<FormItem label="选择时间" :label-width='70'>
							<DatePicker style="width: 110px;" :type="formInline.dateType" placeholder="Select date"
								v-model="formInline.QueryTime"></DatePicker>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
						</FormItem>
					</Form>
				</Card>
				</Col>
			</Row>
			<Card
				style="margin-bottom: 10px;box-shadow: 2px 2px 4px #a7a7a7;width: 100%;background-color: white;">
				<Row>
					<Col span="5">
					<Tag color="success" type="dot">直流设备数量 {{Summary.DcAmount}} 个</Tag>
					</Col>
					<Col span="5">
					<Tag color="primary" type="dot">交流设备数量 {{Summary.AcAmount}} 个</Tag>
					</Col>
					<Col span="4">
					<Tag color="warning" type="dot">总功率 {{Summary.TotolPower}} KW</Tag>
					</Col>
					<Col span="5">
					<Tag color="default" type="dot">合计充电量 {{Summary.ChargeKwh}} KWh</Tag>
					</Col>
					<Col span="5">
					<Tag color="error" type="dot">合计充电收入 {{Summary.ChargeCost}} 元</Tag>
					</Col>
				</Row>
			</Card>
			<Row style="margin-top: 10px;" :gutter="16">
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						充电次数（次）
					</p>
					<div class="echartDiv" id="echart1"></div>
				</Card>
				</Col>
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						充电电量（kwh）
					</p>
					<div class="echartDiv" id="echart2"></div>
				</Card>
				</Col>
			</Row>
			<Row style="margin-top: 10px;" :gutter="16">
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						充电时长（小时）
					</p>
					<div class="echartDiv" id="echart3"></div>
				</Card>
				</Col>
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						充电收入（元）
					</p>
					<div class="echartDiv" id="echart4"></div>
				</Card>
				</Col>
			</Row>
			<Row style="margin-top: 10px;" :gutter="16">
				<Col span=24>
				<Card class="cardStyle" style="height: 600px;">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						<!-- 设备{{formInline.dateType=='month'?'月':'年'}}排行 -->
						充电站排行
					</p>
					<Table :columns="columns1" :data="data1" ref="table"></Table>
				</Card>
				</Col>
			</Row>
		</div>
	</div>
</template>

<script>
	import echart from '../../../js/echarts_hot.js'
	import dateFormat from '../../../../public/js/comm.js'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		data() {
			return {
				BreadcrumbList: ['统计分析', '>>', '互联互通分析'],
				formInline: {
					StationId: 0,
					QueryTime: new Date,
					dateType: 'month',
					PaymentMode: 0,
				},
				//充电设备总计
				Summary: {
					DcAmount: 0,
					AcAmount: 0,
					TotolPower: 0,
					ChargeKwh: 0,
					ChargeCost: 0,
				},
				//图表数据充电次数
				lineEchart: {
					legend_data: ['当前', '上一月'],
					seriesData: [{
							name: '当前',
							type: 'line',
							stack: '当前',
							data: [0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: '上一月',
							type: 'line',
							stack: '上一月',
							data: [0, 0, 0, 0, 0, 0, 0]
						}
					],
					style: {
						color: "black"
					},
					TimePoins: []
				},
				//图表数据充电次数
				lineEchart2: {
					legend_data: ['当前', '上一月'],
					seriesData: [{
							name: '当前',
							type: 'line',
							stack: '当前',
							data: [0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: '上一月',
							type: 'line',
							stack: '上一月',
							data: [0, 0, 0, 0, 0, 0, 0]
						}
					],
					style: {
						color: "black"
					},
					TimePoins: []
				},
				//图表数据充电次数
				lineEchart3: {
					legend_data: ['当前', '上一月'],
					seriesData: [{
							name: '当前',
							type: 'line',
							stack: '当前',
							data: [0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: '上一月',
							type: 'line',
							stack: '上一月',
							data: [0, 0, 0, 0, 0, 0, 0]
						}
					],
					style: {
						color: "black"
					},
					TimePoins: []
				},
				//图表数据充电次数
				lineEchart4: {
					legend_data: ['当前', '上一月'],
					seriesData: [{
							name: '当前',
							type: 'line',
							stack: '当前',
							data: [0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: '上一月',
							type: 'line',
							stack: '上一月',
							data: [0, 0, 0, 0, 0, 0, 0]
						}
					],
					style: {
						color: "black"
					},
					TimePoins: []
				},
				columns1: [{
						title: '充电站名称',
						key: 'StationName',
						// }, {
						// 		title: '设备枪名称',
						// 		key: 'ConnectorName',		
						// }, {
						// 		title: '设备编码',
						// 		key: 'EquipmentNo',		
						// }, {
						// 		title: '设备名称',
						// 		key: 'EquipmentName',
						// }, {
						// 	title: '功率',
						// 	key: 'TotolPower',
					},
					{
						title: '充电量(度)',
						key: 'ChargeKwh'
					},
					{
						title: '充电收入(元)',
						key: 'ChargeCost'
					},
					{
						title: '充电时长(小时)',
						key: 'ChargeDuration'
					},
					{
						title: '充电次数(次)',
						key: 'ChargeNum'
					}
					// {
					// 	title: '利用率(%)',
					// 	key: 'UseRate'
					// },
					// {
					// 	title: '掉线次(次)',
					// 	key: 'OfflineCount'
					// }
				],
				data1: [],
				PaymentModeList: []
			}
		},
		created() {
			this.handleSubmit();
			this.getPaymentModeList();
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		destroyed() {
			echart.disposeEchart(null)
		},
		mounted() {
			//解决刷新页面有时会忽略侧边栏宽度，图表超出容器
			// setTimeout(() => {
			// 	echart.initLinechart3("echart1", this.lineEchart);
			// 	echart.initLinechart3("echart2", this.lineEchart2);
			// 	echart.initLinechart3("echart3", this.lineEchart3);
			// 	echart.initLinechart3("echart4", this.lineEchart4);
			// }, 20)
		},
		deactivated() {
			this.$destroy();
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				const _this = this;
				//echarts数据
				let url = '';
				//总结数据
				let url2 = '';
				//table数据
				let url3 = '';
				let parms = {
					StationId: _this.formInline.StationId,
					QueryTime: _this.formInline.QueryTime == '' ? dateFormat.formatDate(new Date(), 'yyyy-MM-dd') :
						dateFormat.formatDate(
							new Date(_this.formInline.QueryTime), 'yyyy-MM-dd'),
					StatistisRangeType: _this.formInline.dateType == 'year' ? 3 : 2,
					Type: 2,
					PaymentMode: _this.formInline.PaymentMode,
				};
				switch (_this.formInline.dateType) {
					case 'date':
						url = webapi.base_api_url + "/Statistics/GetDailyCurves";
						_this.axiosMethod(url, parms, "echart")
						url2 = '';
						url3 = '';
						break;
					case 'year':
						url = webapi.base_api_url + "/Statistics/GetYearlyCurves";
						_this.axiosMethod(url, parms, "echart")
						url2 = webapi.base_api_url + '/Statistics/GetYearlyStationSummary';
						_this.axiosMethod(url2, parms, "Summary")
						url3 = webapi.base_api_url + '/Statistics/GetStationRank';
						_this.axiosMethod(url3, parms, "table")
						break;
					case 'month':
						url = webapi.base_api_url + "/Statistics/GetMonthlyCurves";
						_this.axiosMethod(url, parms, "echart")
						url2 = webapi.base_api_url + '/Statistics/GetMonthlyStationSummary';
						_this.axiosMethod(url2, parms, "Summary")
						url3 = webapi.base_api_url + '/Statistics/GetStationRank';
						_this.axiosMethod(url3, parms, "table")
						break;
				}
			},
			axiosMethod: function(url, parms, type) {
				const _this = this;
				_this.$axios.post(url, parms, {
				}).then(res => {
					console.log("axiosMethod")
					console.log(type)
					if (res.data.Code == 0) {
						switch (type) {
							case "echart":
								_this.dealEchart(res)
								break;
							case "Summary":
								_this.dealSummary(res)
								break;
							case "table":
								_this.dealTable(res)
								break;
							default:
								break;
						}
					}
				})
			},
			dealEchart: function(res) {
				const _this = this;
				let MyTimePoins = []
				switch (_this.formInline.dateType) {
					case 'date':
						res.data.Data.Curves.TimePoins.forEach(function(time) {
							MyTimePoins.push(time.split(" ")[1] + ":00")
						})
						break;
					case 'year':
						res.data.Data.Curves.TimePoins.forEach(function(time) {
							MyTimePoins.push(time.split("-")[1] + "月")
						})
						break;
					case 'month':
						res.data.Data.Curves.TimePoins.forEach(function(time) {
							MyTimePoins.push(time.split("-")[2] + "号")
						})
						break;
				}
				_this.lineEchart.TimePoins = MyTimePoins
				_this.lineEchart.seriesData[0].data = res.data.Data.Curves.ChargeNum.Current
				_this.lineEchart.seriesData[1].data = res.data.Data.Curves.ChargeNum.Previos

				_this.lineEchart2.TimePoins = MyTimePoins
				_this.lineEchart2.seriesData[0].data = res.data.Data.Curves.ChargeKwh.Current
				_this.lineEchart2.seriesData[1].data = res.data.Data.Curves.ChargeKwh.Previos


				_this.lineEchart3.TimePoins = MyTimePoins
				_this.lineEchart3.seriesData[0].data = res.data.Data.Curves.ChargeDuration.Current
				_this.lineEchart3.seriesData[1].data = res.data.Data.Curves.ChargeDuration.Previos

				_this.lineEchart4.TimePoins = MyTimePoins
				_this.lineEchart4.seriesData[0].data = res.data.Data.Curves.ChargeRevenue.Current
				_this.lineEchart4.seriesData[1].data = res.data.Data.Curves.ChargeRevenue.Previos

				echart.initLinechart3("echart1", this.lineEchart);
				echart.initLinechart3("echart2", this.lineEchart2);
				echart.initLinechart3("echart3", this.lineEchart3);
				echart.initLinechart3("echart4", this.lineEchart4);

				echart.upEchartOpt(null);
			},
			dealSummary: function(res) {
				console.log("dealSummary")
				console.log(res)
				this.Summary = res.data.Data.Curves
			},
			dealTable: function(res) {
				console.log("dealTable")
				console.log(res)
				this.data1 = res.data.Data
			},
			changelegend_data: function() {
				const _this = this
				switch (_this.formInline.dateType) {
					case 'date':
						_this.lineEchart.legend_data = ['当前', '上一日'];
						_this.lineEchart.seriesData[1].name = '上一日';

						_this.lineEchart2.legend_data = ['当前', '上一日'];
						_this.lineEchart2.seriesData[1].name = '上一日';

						_this.lineEchart3.legend_data = ['当前', '上一日'];
						_this.lineEchart3.seriesData[1].name = '上一日';

						_this.lineEchart4.legend_data = ['当前', '上一日'];
						_this.lineEchart4.seriesData[1].name = '上一日';
						break;
					case 'year':
						_this.lineEchart.legend_data = ['当前', '上一年'];
						//_this.$set(_this.lineEchart.legend_data,1,'上一年')
						_this.lineEchart.seriesData[1].name = '上一年';

						_this.lineEchart2.legend_data = ['当前', '上一年'];
						_this.lineEchart2.seriesData[1].name = '上一年';

						_this.lineEchart3.legend_data = ['当前', '上一年'];
						_this.lineEchart3.seriesData[1].name = '上一年';

						_this.lineEchart4.legend_data = ['当前', '上一年'];
						_this.lineEchart4.seriesData[1].name = '上一年';
						break;
					case 'month':
						_this.lineEchart.legend_data = ['当前', '上一月'];
						_this.lineEchart.seriesData[1].name = '上一月';

						_this.lineEchart2.legend_data = ['当前', '上一月'];
						_this.lineEchart2.seriesData[1].name = '上一月';

						_this.lineEchart3.legend_data = ['当前', '上一月'];
						_this.lineEchart3.seriesData[1].name = '上一月';

						_this.lineEchart4.legend_data = ['当前', '上一月'];
						_this.lineEchart4.seriesData[1].name = '上一月';
						break;
				}
				_this.handleSubmit()
			},
			getPaymentModeList() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + '/Common/GetEvcsPaymentModeList').then(res => {
					if (res.data.Code == 0) {
						_this.PaymentModeList = res.data.Data.List;
					}
				});
			}
		}
	}
</script>

<style>
	.cardStyle {
		margin-bottom: 20px !important;
		box-shadow: 2px 2px 4px #a7a7a7;
		width: 100% !important;
		color: #000000;
		background-color: #ffffff !important;
		height: 334px;
	}

	.cardStyle p {
		text-align: left;
		color: #000000 !important;
	}

	.cardStyle .echartDiv {
		height: 250px;
	}

	.echartDiv {
		background-color: #ffffff;
	}
</style>
